module.exports = __webpack_public_path__ + "static/media/img-09-phone@2x_en.2077459f.png";